import { Flex } from "antd";
import React from "react";
import IconBackArrow from "@/components/icons/IconBackArrow";
import { useLocation, useNavigate } from "react-router-dom";

const BackWithLabel = ({ path = "/", label }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1); // Go back to the actual previous page in browser history
    } else {
      navigate(path); // If no history, go to fallback path
    }
  };
  return (
    <Flex wrap gap="small" align="center">
      <IconBackArrow className="cursor-pointer" onClick={() => handleBack()} />
      <div className="title-h5-1">{label}</div>
    </Flex>
  );
};

export default BackWithLabel;
